export default __webpack_public_path__ + "static/media/autochartist_white.80e57cf5.svg";